import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {FormManagerService} from './services/form-manager.service';


@NgModule({
  declarations: [],
  exports: [
    FormsModule,
    ReactiveFormsModule,
  ],
  imports: [
    CommonModule,
    MatSnackBarModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class FormModule {
  static forRoot(): ModuleWithProviders<FormModule> {
    return {
      ngModule: FormModule,
      providers: [
        FormManagerService,
      ],
    };
  }

  constructor() {
  }
}
